import { Link } from "react-router-dom";
import { site, navItems } from "../data/site";
import { IconPhone, IconMail, IconPin, IconArrow } from "./icons";
import styles from "./Footer.module.css";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <div className={styles.brandCol}>
          <Link to="/" className={styles.brand}>
            <span className={styles.brandMark}>
              <svg viewBox="0 0 28 28" width="32" height="32" aria-hidden="true">
                <path
                  d="M4 22 L14 6 L24 22 M9 22 L14 14 L19 22"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
            <span>
              <span className={styles.brandWord}>UPSHOT</span>
              <span className={styles.brandSub}>Architecture</span>
            </span>
          </Link>
          <p className={styles.tag}>{site.tagline}</p>
          <Link to="/contact" className={styles.startCta}>
            Start a Project <IconArrow />
          </Link>
        </div>

        <div className={styles.col}>
          <h4 className={styles.h}>Studio</h4>
          {navItems.map((item) => (
            <Link key={item.path} to={item.path}>
              {item.label}
            </Link>
          ))}
        </div>

        <div className={styles.col}>
          <h4 className={styles.h}>Contact</h4>
          <a href={`mailto:${site.email}`} className={styles.contactRow}>
            <IconMail /> {site.email}
          </a>
          <a href={`tel:${site.phoneTel}`} className={styles.contactRow}>
            <IconPhone /> {site.phone}
          </a>
          <span className={styles.contactRow}>
            <IconPin /> {site.city}
          </span>
        </div>

        <div className={styles.col}>
          <h4 className={styles.h}>Notice</h4>
          <span className={styles.muted}>
            {site.principal}
            <br />
            Licensed in Montana
            <br />
            AIA Member
          </span>
        </div>
      </div>

      <div className={styles.legal}>
        <span>© {year} {site.fullName}. All rights reserved.</span>
        <span className={styles.legalRight}>
          <span className={styles.mono}>BZN · MT · {site.founded}–{year}</span>
        </span>
      </div>
    </footer>
  );
}
